import { render } from "./destinationDetailsModal.vue?vue&type=template&id=edb92f4a&scoped=true"
import script from "./destinationDetailsModal.vue?vue&type=script&lang=js"
export * from "./destinationDetailsModal.vue?vue&type=script&lang=js"

import "./destinationDetailsModal.vue?vue&type=style&index=0&id=edb92f4a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edb92f4a"]])

export default __exports__